<app-message></app-message>
@if (isLanguageLoaded) {
  <router-outlet></router-outlet>
}
<app-rc-footer [version]="version"></app-rc-footer>
@if (env.isRoyalCanin) {
  @if (showCookiesButton) {
    <app-cookie-settings-button></app-cookie-settings-button>
  }
}
